import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import styles from './SharedRespMoreWaysToBrowse.scss';

const SharedRespMoreWaysToBrowseComponent = ({ internalBuyLinks }) => {
    const title = (
        <FormattedMessage
            id="SharedRespMoreWaysToBrowse.title"
            defaultMessage="More Ways to Browse"
        />
    );

    if (internalBuyLinks && internalBuyLinks.length) {
        return (
            <div data-tn="sb-resp-more-ways-to-browse" className={styles.wrapper}>
                <BarHeader title={title} />
                <div className={`${styles.links} rowFlex`}>
                    {internalBuyLinks.map(({ anchorText, url }) => (
                        <div key={url} className={`${styles.link} colXs12 colMd4`}>
                            <a href={url}>{anchorText}</a>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return null;
};

SharedRespMoreWaysToBrowseComponent.propTypes = {
    internalBuyLinks: PropTypes.arrayOf(
        PropTypes.shape({
            anchorText: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export const SharedRespMoreWaysToBrowse = createFragmentContainer(
    SharedRespMoreWaysToBrowseComponent,
    {
        internalBuyLinks: graphql`
            fragment SharedRespMoreWaysToBrowse_internalBuyLinks on InternalBuyLinkType
                @relay(plural: true) {
                anchorText
                url
            }
        `,
    }
);
